<template>
  <div
    style="
      overflow-y: scroll;
      width: 100%;
      height: 270px;
      display: block;
      padding-right: 10px;
      padding-left: 10px;
    "
  >
    <div v-if="config.company == 'Skellefteå Taxi'">
      <br />
      <h2>Välkommen att<br />ringa till oss</h2>
      <br />
      <h4>Vi har öppet dygnet runt</h4>

      <span style="font-size: 14px">
        Boka på
        <br />
        <a href="tel:+4691017000">+46910-170 00</a><br />
        Färdtjänst<br /><a :href="'tel:' + config.customer.tele">{{
          config.customer.tele
        }}</a
        ><br />
        <span style="padding-top: 15px; font-size: 14px"
          >För att boka sjukresa ring <br /><a href="tel:+46771251020"
            >+46 771 25 10 20</a
          ></span
        ></span
      >
    </div>
    <div
      v-if="
        config.company !== 'Skellefteå Taxi' &&
        config.customer.showCallback === false
      "
    >
      <div
        v-if="error"
        style="width: 100%; font-size: 11px; margin-top: 20px; color: red"
      >
        Något är fel med uppkopplingen...
      </div>
      <div v-else style="width: 100%; font-size: 11px; margin-top: 10px">
        <span
          v-if="!addContactInfo"
          @click="closePopup()"
          class="material-icons"
          style="
            font-size: 30px;
            cursor: pointer;
            position: absolute;
            top: 60px;
            right: 10px;
          "
          >close</span
        >
      </div>
      <h4>Kontaktuppgifter</h4>
      <br /><br />
      <div>
        <b>Telefon: </b>
        <a :href="'tel:' + config.customer.tele">{{ config.customer.tele }}</a>
      </div>
      <div><b>E-post:</b> {{ config.customer.email }}</div>
      <br />
    </div>

    <div v-if="smsView" style="">
      <div v-if="config.customer.showCallback">
        <div style="margin-top: 10px">Begär återuppringning</div>
        <v-form ref="form" v-model="valid" :lazy-validation="lazy">
          <div style="">
            <v-text-field
              color="#006eb0"
              class="custom-label-color"
              style="float: left; width: 50%; margin-right: 15px"
              label="Ditt nummer..."
              clearable
              v-model="phoneNumber"
              :rules="rulesPhoneNumber"
            >
            </v-text-field>
          </div>
          <div style="padding-top: 0px">
            <v-select
              :items="timesToCallback"
              :menu-props="{ top: true, offsetY: true }"
              color="#006eb0"
              label="När?"
              class="custom-label-color"
              style="width: 40%"
              v-model="message"
              :rules="rulesWhenCallingBack"
            ></v-select>
          </div>
          <div style="width: 100%; float: right; height: 20px">
            <v-btn
              color="#006eb0"
              style="color: white"
              :disabled="!valid"
              @click="addCallback(0, '')"
              >Begär callback</v-btn
            >
          </div>
        </v-form>
      </div>
    </div>
    <div style="padding: 20px" v-else>
      <h3>Tack för din begäran</h3>
      <div>Vi kommer att återkomma.</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Phone",
  props: ["config"],
  data() {
    return {
      addCallbackVerified: true,
      smsView: true,
      message: "",
      timesToCallback: ["Omgående", "Idag", "Imorgon"],
      phoneNumber: "",
      valid: false,
      lazy: false,
      rulesTextField: [
        (v) => v.length <= 160 || "Max 160 ord.",
        (v) => !!v || "Du måste skriva något.",
        (v) => v.length > 5 || "Du måste skriva minst 5 ord.",
      ],
      rulesPhoneNumber: [
        (v) => v.length >= 6 || "Numret måste vara minst 6 tecken",
        (v) => !!v || "Du måste ange ett nummer",
      ],
      rulesWhenCallingBack: [
        (v) => !!v || "Du måste ange en tidpunkt vi kan ringa tillbaka",
      ],
      value: "",
      error: false,
    };
  },
  methods: {
    callNow(nr) {
      window.location.href = "callto:" + nr;
    },
    addCallback(userId, email) {
      const visitorId = localStorage.getItem("visitorId");

      const dataToSend = {
        userId: 0,
        message: this.message,
        phoneNumber: this.phoneNumber,
        type: "callback",
        visitorId: visitorId,
        agentName: "Test",
        agentUserId: 0,
        agentEmail: email,
        visitorInfo: { visitorEmail: this.phoneNumber },
      };

      this.$store.dispatch("sendCallback", dataToSend);

      this.smsView = false;
      let self = this;
      setTimeout(() => {
        self.smsView = false;
      }, 5000);
    },
    closePopup() {
      this.$store.dispatch("goBack");
    },
  },
};
</script>